<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-md-8">
                  <div class="text-primary p-4">
                    <h5 class="text-primary">Redefinir Senha</h5>
                  </div>
                </div>
                <div class="col-md-4 align-self-end">
                  <img src="@/assets/images/unicampo.jpg" height="100" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div class="p-2">
                <div class="row">
                  <b-form-group
                    class="mb-3"
                    label="Senha atual"
                    invalid-feedback="Digite sua senha atual"
                  >
                    <b-form-input
                      v-model="senhaAtual"
                      :type="inputType"
                      trim
                      style="width: 90% !important; display: unset"
                    >
                    </b-form-input>
                    <button
                      class="btn btn-light btn-outline-secondary"
                      type="button"
                      @click="togglePassword()"
                      tabindex="-1"
                    >
                      <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
                      <i v-else class="mdi mdi-eye-off-outline"></i>
                    </button>
                  </b-form-group>
                </div>

                <div class="row">
                  <b-form-group
                    class="mb-3"
                    label="Nova senha"
                    invalid-feedback="Digite uma senha que atenda a todas as exigências"
                  >
                    <b-form-input
                      v-model="senhaNova"
                      :type="inputType"
                      @blur="verificarSenhaIgual()"
                      @keyup="verificarSenhaIgual()"
                      @input="verificarSenha(senhaNova)"
                      :state="validacaoSenha"
                      trim
                      style="width: 90% !important; display: unset"
                    >
                    </b-form-input>
                    <button
                      class="btn btn-light btn-outline-secondary"
                      type="button"
                      @click="togglePassword()"
                      tabindex="-1"
                    >
                      <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
                      <i v-else class="mdi mdi-eye-off-outline"></i>
                    </button>
                  </b-form-group>
                  <div>
                    <p class="fst-italic text-danger" v-if="tamanhoSenha">
                      De 10 à 20 caracteres
                    </p>
                    <p class="fst-italic text-danger" v-if="minusculaSenha">
                      Letra minúscula
                    </p>
                    <p class="fst-italic text-danger" v-if="maiusculaSenha">
                      Letra maiúscula
                    </p>
                    <p class="fst-italic text-danger" v-if="numeroSenha">
                      Número
                    </p>
                    <p
                        class="fst-italic text-danger"
                        v-if="simbolosPermitidosSenha"
                      >
                      Símbolos obrigatórios ! ? ¨ - *
                      </p>
                      <p
                        class="fst-italic text-danger"
                        v-if="simbolosNaoPermitidosSenha"
                      >
                      Símbolos não permitidos: @, #, &, , /, +, %

                      </p>
                  </div>
                </div>

                <div class="row">
                  <b-form-group
                    class="mb-3"
                    label="Confirmação de senha *"
                    invalid-feedback="As senhas devem ser iguais e atender a todas as exigências."
                  >
                    <b-form-input
                      v-model="senhaConfirmacao"
                      @blur="verificarSenhaIgual()"
                      @keyup="verificarSenhaIgual()"
                      @paste="disablePaste"
                      :state="validacaoSenhaIgual"
                      :type="inputType"
                      trim
                      style="width: 90% !important; display: unset"
                    ></b-form-input>
                    <button
                      class="btn btn-light btn-outline-secondary"
                      type="button"
                      @click="togglePassword()"
                      tabindex="-1"
                    >
                      <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
                      <i v-else class="mdi mdi-eye-off-outline"></i>
                    </button>
                  </b-form-group>
                </div>

                <div class="form-group row mb-0 mt-2">
                  <div class="col-12 text-end">
                    <button
                      class="btn btn-primary w-md"
                      @click="redefinir"
                      :disabled="disabledRedefinir"
                    >
                      Redefinir
                      <b-spinner
                        class="ms-2"
                        small
                        variant="secondary"
                        v-if="loadingRedefinir"
                      ></b-spinner>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import redefinirSenhaMixin from "@/tools/mixins/redefinirSenhaMixin.js";
export default {
  data() {
    return {
      emailToken: "",
      senhaAtual: "",
      senhaNova: "",
      senhaConfirmacao: "",
      validacaoSenhaIgual: null,
      validacaoSenha: null,
      tamanhoSenha: true,
      minusculaSenha: true,
      maiusculaSenha: true,
      numeroSenha: true,
      simbolosPermitidosSenha: true,
      simbolosNaoPermitidosSenha: true,
      inputType: "password",
      loadingRedefinir: false,
      sq_usuario: this.$store.state.me.sq_usuario,
      usuarioLogado: true,
    };
  },

  mixins: [redefinirSenhaMixin],

  page: {
    title: "Redefinir Senha",
  },

  created() {
    if (!this.$store.state.access_token) {
      this.$router.push("/login");
    }
  },

  computed: {
    isPassword() {
      return this.inputType === "password";
    },

    disabledRedefinir() {
      const invalidaSenha =
        this.validacaoSenha !== true ||
        this.validacaoSenhaIgual !== true ||
        this.senhaAtual === "" ||
        this.loadingRedefinir === true;
      return invalidaSenha;
    },
  },

  methods: {
    async redefinir() {
      this.loadingRedefinir = true;
      try {
        const redefinirSenha = await this.redefinirSenha();
        this.$tools.alerta(redefinirSenha.data.message, "success");
        this.logoutUser();
      } catch (err) {
        this.loadingRedefinir = false;
        this.$tools.alerta(err.response.data.message, "error");
      }
    },
  },
};
</script>